'use client';

import { __spreadArray, __assign, __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { useState, useMemo, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ArrowBackIcon from '../../Images/ArrowBackIcon/index.js';
import { Wrapper, Header, MainContainer, ScrollableContainer, List, EmptyPlaceholder } from './MobileDialog.css.js';
import SingleRadio from '../../SingleRadio/index.js';
import Search from '../Dropdown/Search/index.js';
import { useMultipleRadioGroupContext, MAX_ADDITIONAL_ITEMS } from '../context.js';
import { transformToLatin } from '../../Utils/helpers.js';
import { Span } from '../../Typography/components/Variant.js';
import { searchCompanyIndustries } from '../services.js';
import { ELanguage } from '../../Utils/constants.js';
import useDebounce from '../../Utils/hooks.js';

var MobileDialog = function (_a) {
    var onCancel = _a.onCancel, mobilePopupTitle = _a.mobilePopupTitle, msBaseUrl = _a.msBaseUrl, isEnableSearchAPI = _a.isEnableSearchAPI, langCode = _a.langCode;
    var _b = useMultipleRadioGroupContext(), handleChange = _b.handleChange, dropdown = _b.dropdown, options = _b.options, selectedItem = _b.selectedItem, name = _b.name, fieldLabel = _b.fieldLabel;
    var _c = dropdown || {}, _d = _c.isLeftRadio, isLeftRadio = _d === void 0 ? true : _d, _e = _c.hoverBgOff, hoverBgOff = _e === void 0 ? false : _e, _f = _c.emptyText, emptyText = _f === void 0 ? 'No result found' : _f, _g = _c.isSearchable, isSearchable = _g === void 0 ? false : _g, _h = _c.searchBoxPlaceholder, searchBoxPlaceholder = _h === void 0 ? 'Search' : _h, _j = _c.customOptionItem, customOptionItem = _j === void 0 ? function () { return null; } : _j, _k = _c.searchFields, searchFields = _k === void 0 ? ['name'] : _k;
    var _l = useState(''), searchText = _l[0], setSearchText = _l[1];
    var _m = useState([]), searchResult = _m[0], setSearchResult = _m[1];
    var debounceKeyword = useDebounce([searchText], 300);
    var handleClickItem = function (value) {
        setTimeout(function () {
            setSearchText('');
        }, 200);
        handleChange(value);
    };
    var handleSetSearchText = function (value) {
        setSearchText(transformToLatin(value));
    };
    var getSearchResult = function (keyword) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (keyword === '') {
                        setSearchResult([]);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, searchCompanyIndustries(msBaseUrl, keyword)];
                case 1:
                    response = _b.sent();
                    setSearchResult((_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : []);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderOptions = useMemo(function () {
        var _a, _b;
        var responseOptions = options.filter(function (option) {
            if (searchText === '')
                return true;
            var optionSearch = '';
            searchFields.map(function (field) {
                optionSearch += option[field];
            });
            return transformToLatin(optionSearch).indexOf(searchText) > -1;
        });
        if (isEnableSearchAPI && searchResult.length > 0) {
            var responseAPI = [];
            var _loop_1 = function (i) {
                var companyItem = searchResult[i];
                if (!companyItem) {
                    return "continue";
                }
                if (responseAPI.length >= MAX_ADDITIONAL_ITEMS) {
                    return "break";
                }
                var filteredMatch = responseOptions.filter(function (item) { return item.id === companyItem.id; });
                if (filteredMatch.length > 0) {
                    return "continue";
                }
                else {
                    responseAPI.push({
                        id: companyItem.id,
                        name: langCode === ELanguage.VI
                            ? (_a = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _a === void 0 ? void 0 : _a.nameVi
                            : (_b = companyItem === null || companyItem === void 0 ? void 0 : companyItem.attributes) === null || _b === void 0 ? void 0 : _b.nameEn
                    });
                }
            };
            for (var i = 0; i < searchResult.length; i++) {
                var state_1 = _loop_1(i);
                if (state_1 === "break")
                    break;
            }
            responseOptions = __spreadArray(__spreadArray([], responseOptions, true), responseAPI, true);
        }
        return responseOptions;
    }, [searchText, searchResult, options]);
    useEffect(function () {
        if (!debounceKeyword) {
            return;
        }
        getSearchResult(searchText);
    }, [debounceKeyword]);
    if (typeof window === 'undefined')
        return React__default.createElement(React__default.Fragment, null);
    return ReactDOM.createPortal(React__default.createElement(Wrapper, null,
        React__default.createElement(Header, null,
            React__default.createElement(ArrowBackIcon, { onClick: onCancel }),
            React__default.createElement(Span, { size: 'medium', name: 'title', style: { marginLeft: 24 } }, mobilePopupTitle || '')),
        React__default.createElement(MainContainer, null,
            isSearchable && (React__default.createElement(Search, { searchText: searchText, placeholder: searchBoxPlaceholder, onChange: handleSetSearchText })),
            React__default.createElement(ScrollableContainer, null,
                React__default.createElement(List, null,
                    renderOptions.map(function (option) {
                        var id = option.id;
                        return (React__default.createElement("li", { key: id },
                            React__default.createElement(SingleRadio, { id: id, label: option[fieldLabel], onChange: function () { return handleClickItem(option); }, name: name, checked: id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id), isLeftRadio: isLeftRadio, hoverBgOff: hoverBgOff, noBg: true, customValue: customOptionItem(__assign(__assign({}, option), { active: id === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.id) })) })));
                    }),
                    renderOptions.length === 0 && (React__default.createElement("li", null,
                        React__default.createElement(EmptyPlaceholder, null, emptyText))))))), document.body);
};

export { MobileDialog as default };
//# sourceMappingURL=index.js.map
